function preventEnterSubmittingHandler(e) {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
}

export {preventEnterSubmittingHandler};



// WEBPACK FOOTER //
// ./src/views/fragments/forms/helpers.js